import StudentInfo from "@/pages/cursisten/$studentId/gegevens"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute("/beheer/cursisten/$studentId/gegevens/")({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "students"),
})

function RouteComponent() {
  const { studentId } = useParams({ from: "/beheer/cursisten/$studentId" })

  return <StudentInfo studentId={Number(studentId)} />
}
